export const CompareExperimentTabs = {
  OUTPUTS: 0,
  CHARTS: 1,
} as const;

export const CompareExperimentTabsArray = Object.values(CompareExperimentTabs);
